/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { FormGroup } from 'react-bootstrap';
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { cloneDeep, isEmpty, uniqBy } from 'lodash';
import * as action from '../../store/DevelopmentOrder.action';
import * as testAction from '../../../Library/Testing/Store/Testing.action';
import { SystemMasterSelect, shortenandHoverString, colourWayOptions } from '../../../../Components/helper';
import ForPreview from '../ForPreview';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import UploadTesting from '../UploadTesting';

const customStyles = {
  option: (provided) => ({
    ...provided,
    padding: '5px 10px',
  }),
  control: () => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    borderBottom: '1px solid #848484',
    zIndex: 5,
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';
    return { ...provided, opacity, transition };
  },
  menu: (provided) => ({
    ...provided,
    margin: '-1px 0 0 0',
    border: '1px solid #848484',
    borderRadius: 0,
    zIndex: 99999, // Increased z-index to ensure menu appears above all other elements
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    color: '#555',
    zIndex: 5,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#848484',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
};

function TopTable({
  showData,
  handleSelectedTest,
  selectedType,
  handleSelectedSupplier,
  supplier,
  handleSelectedColour,
  fromTestingLib,
  colour,
  devOrderID,
  state,
  setSupplier,
  setColour,
  testTypeMaster,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const testingGroupReduxData = useSelector((redState) => redState);
  const { Measuremets, SuppliersDetails, TestDetails, UserDetails } = testingGroupReduxData;
  const { testList } = TestDetails;
  const { userInfo } = UserDetails;
  const loggedInUserId = userInfo.userId;
  const { ProductColourList, testingAttributes } = Measuremets;
  const { tier2AndAboveList, tier1List } = SuppliersDetails;
  const dateFormat = 'DD-MMMM-YYYY, h:mm a';
  const [renewState, setReNewState] = useState({
    documentLibId: [],
    reportIds: [],
    renewName: '',
    renewStatus: [],
    testIds: [],
    showDropZone: true,
  });

  const [supplierOptions, setSupplierOptions] = useState([]);
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [type, setType] = useState(null);
  const [selectedItem, setSelecteditem] = useState(null);
  const [savedEdit, setSavedEdit] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [expectedExpairy, setExpectedExpairy] = useState('');
  const [fromRenew, setFromRenew] = useState(false);
  const [showConfirmationReDo, setShowConfirmationReDo] = useState(false);
  const [addClassname, setAddClassname] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [increaseZIndex, setIncreaseZIndex] = useState(false);

  useEffect(() => {
    setSelecteditem(selectedType);
  }, [selectedType]);

  useEffect(() => {
    if (testList && selectedItem) {
      const clonseSelected = cloneDeep(selectedItem);
      const filterData = testList.filter((list) => list._id === clonseSelected._id);
      clonseSelected.testReport = {
        _id: filterData[0]?.testReport?._id,
        pdf: filterData[0]?.testReport?.pdf,
        pdfTitle: filterData[0]?.testReport?.pdfTitle,
        expiryDate: filterData[0]?.testReport?.expiryDate,
      };
      setSelecteditem(clonseSelected);
    }
  }, [testList]);

  useEffect(() => {
    if (!Array.isArray(testingAttributes) && selectedItem) {
      const clonedSelected = cloneDeep(selectedItem);
      clonedSelected.testReport = {
        _id: testingAttributes?._id,
        pdfTitle: testingAttributes?.pdfTitle,
        expiryDate: testingAttributes?.expiryDate,
      };
      setSelecteditem(clonedSelected);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingAttributes]);

  useEffect(() => {
    const suppArray = [...tier1List, ...tier2AndAboveList];
    const upnewArr = uniqBy(suppArray, (e) => e._id);
    setSupplierOptions([...upnewArr]);
  }, [tier2AndAboveList, tier1List]);

  const handleRenew = () => {
    setReNewState((prevRenewState) => ({
      prevRenewState,
      documentLibId: [showData?._id],
      reportIds: [selectedItem?.testReport?._id],
      renewName: selectedItem?.testReport?.pdfTitle,
      renewStatus: selectedItem?.status,
      testIds: [selectedItem._id],
      showDropZone: true,
    }));
    setFromRenew(true);
    setShowPdfModal(true);
  };

  const togglePdfModal = async () => {
    setShowPdfModal(!showPdfModal);
    setFromRenew(false);
    setReNewState((clearState) => ({
      clearState,
      documentLibId: [],
      reportIds: [],
      renewName: '',
      renewStatus: [],
      testIds: [],
      showDropZone: true,
    }));
    setExpectedExpairy('');
    setSelectedIdArray([]);
    await dispatch(action.clearReducer());
    await dispatch(
      action.colourProductTesting({
        loggedInUserId,
      }),
    );
  };

  const handleEdit = (item) => {
    setSavedEdit(true);
    const typ = testTypeMaster.filter((ele) => ele._id === item.type._id);
    setType(...typ);
  };

  const handleSave = async (ele) => {
    const emptyMinPassRate = ele.minPassRate === null || ele.minPassRate === '';
    const emptyTestType = ele.type === null || ele.type === '';
    if (!emptyMinPassRate && !emptyTestType) {
      await forUpdate();
    } else {
      await onNewEntery();
    }
  };

  const onNewEntery = () => {
    if (isEmpty(selectedItem.type) || selectedItem.type === null || selectedItem.type !== '' || isEmpty(selectedItem.minPassRate)) {
      return { ...selectedItem, isEmpty: true };
    }
  };

  const forUpdate = async () => {
    const put_params = {
      id: selectedItem?._id,
      additionalInformation: selectedItem?.additionalInformation,
      code: selectedItem?.code,
      description: selectedItem?.description,
      minPassRate: selectedItem?.minPassRate,
      type: type?._id, // selectedItem?.type
      bomComponent: showData?.libId,
      supplier: selectedItem?.supplier?._id,
      colour: selectedItem?.colourComponent?._id,
    };
    await dispatch(testAction.updateTesting(put_params, t));
    setSavedEdit(false);
    const response = await dispatch(testAction.getAllTest());
    if (response) {
      const newEvent = response.data.filter((ele) => ele._id === selectedItem._id);
      await handleSelectedTest(newEvent[0]);
    }
    if (!fromTestingLib) {
      const getAttributes = {
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        devOrderId: devOrderID,
        bomComponent: showData.libId,
        bomcomponentLibId: showData.libId,
      };
      await dispatch(action.fetchProductBomTesting(getAttributes));
    } else {
      const getAttributes = {
        pageIndex: state.pageIndex,
        pageSize: state.pageSize,
        devOrderId: devOrderID,
        bomComponent: showData?.libId,
      };
      devOrderID && (await dispatch(action.getTestingAtrribute(getAttributes)));
    }
  };

  const handleCancle = () => {
    setSavedEdit(false);
  };

  const openForPreview = () => {
    setShowPreviewModal(true);
  };

  const showCreatedandModified = (item) => {
    return (
      <button type="button" className="btn btn-action-icon m-0">
        <div className="info-container ml-0">
          <span className="icon-info  f-18" />
          <div className="info-content" style={{ width: '250px' }}>
            {item?.createdBy?.firstName && (
              <p className="text-left m-0">
                <strong> {t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.CREATED')} </strong> :{' '}
                {`${item?.createdBy?.firstName} ${item?.createdBy?.lastName} | `}
                {moment(item?.createdAt).format(dateFormat)}
              </p>
            )}
            {item?.modifiedBy?.firstName && (
              <p className="text-left m-0">
                <strong>{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.MODIFIED')}</strong> :{' '}
                {`${item?.modifiedBy?.firstName} ${item?.modifiedBy?.lastName} | `}
                {moment(item?.updatedAt).format(dateFormat)}
              </p>
            )}
          </div>
        </div>
      </button>
    );
  };

  const openModal = () => {
    setReNewState((singleUp) => ({
      singleUp,
      documentLibId: [showData?._id],
      reportIds: [selectedItem?.testReport?._id],
      renewName: '',
      renewStatus: [showData?.status],
      testIds: [selectedItem?._id],
      showDropZone: true,
    }));
    setShowPdfModal(true);
  };

  const actionButtons = (item) => {
    return savedEdit ? (
      <td className="col-id-no testing-action">
        <button
          title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.SAVE')}
          type="button"
          className="btn"
          onClick={() => handleSave(item)}
          aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.SAVE')}
        >
          <span className="icon-Save" />
        </button>
        <button className="btn" type="button" onClick={() => handleCancle()} aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.CANCEL')}>
          <span className="icon-cancel" />
        </button>
      </td>
    ) : (
      <td className="col-id-no">
        <div className="action-btns testing-action d-flex align-items-center">
          {item && showCreatedandModified(item)}
          <button
            type="button"
            title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.EDIT')}
            className="btn"
            onClick={() => handleEdit(item)}
            disabled={!selectedItem}
            aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.EDIT')}
          >
            <span className="icon-edit" />
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => openForPreview()}
            title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.PREVIEW')}
            disabled={!selectedItem || !supplier}
            aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.PREVIEW')}
          >
            <span className="icon-preview-template" />
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => openModal()}
            title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.UPLOAD')}
            disabled={!selectedItem || !supplier}
            aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.UPLOAD')}
          >
            <span className="icon-upload" />
          </button>
          <button
            type="button"
            className="btn"
            onClick={() => handleRenew()}
            title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.RENEW')}
            disabled={!selectedItem || !supplier}
            aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.RENEW')}
          >
            <span className="upicon-renew" />
          </button>
          {!(item?.status === 'pending' || item?.status === 'Pending' || !item?.status) && (
            <button
              type="button"
              className="btn"
              onClick={() => handleRedotheStatus()}
              title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.CLEAR_STAUS')}
              disabled={!selectedItem}
              aria-label={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.CLEAR_STAUS')}
            >
              <span className="icon-cancel" />
            </button>
          )}
        </div>
      </td>
    );
  };

  const undoStatus = async () => {
    await dispatch(testAction.deleteTestStatus({ testCaseIds: showData._id }, t));
    await dispatch(testAction.getAllTest());
    setShowConfirmationReDo(!showConfirmationReDo);
  };

  const handleRedotheStatus = () => {
    setShowConfirmationReDo(!showConfirmationReDo);
  };

  const statuSet = () => {
    switch (selectedItem?.status) {
      case 'true':
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.APPROVED')}</span>
            <span className="col-status right approved" />
          </>
        );

      case 'false':
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.REJECT')}</span>
            <span className="col-status right rejected" />
          </>
        );

      default:
        return (
          <>
            <span>{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.PENDING')}</span>
            <span className="col-status right pending" />
          </>
        );
    }
  };

  const statusCalled = () => {
    return selectedItem?.status ? (
      statuSet()
    ) : (
      <>
        <span>{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.PENDING')}</span>
        <span className="col-status right pending" />
      </>
    );
  };

  const handleComments = (ele) => {
    return (
      <td className="position-relative">
        <div className="document-title position-static">
          <span>
            {ele?.result && `${ele?.result} | `} {ele?.comment && <br />}
            {statusCalled()}
            {ele?.status !== 'pending' || ele?.status !== null || ele?.status !== 'Pending' ? null : (
              <div className="info-container">
                <span className="icon-info  f-18" />
                <div className="info-content">
                  <p className="mb-1 ">
                    {ele?.approveRejectedBy && `${ele?.approveRejectedBy.firstName} ${ele?.approveRejectedBy.lastName} | `}
                    {moment(ele?.approvedAt).format(dateFormat)}
                  </p>
                  {ele?.comment && <p className="mb-0 comment-box ">{ele?.comment}</p>}
                </div>
              </div>
            )}
          </span>
        </div>
      </td>
    );
  };

  const handleSelectType = (eve) => {
    setType(eve);
    setSelecteditem({ ...selectedItem, type: eve?._id });
  };

  const handleChange = (event) => {
    // partial commit
    const fieldName = event?.target?.name;
    const value = event?.target?.value;
    const copyState = { ...selectedItem };
    copyState[fieldName] = value;
    setSelecteditem({ ...selectedItem, ...copyState });
  };

  const togglePreview = async () => {
    setShowPreviewModal(!showPreviewModal);
    setReNewState((initState) => ({
      initState,
      documentLibId: [],
      reportIds: [],
      renewName: '',
      renewStatus: [],
      testIds: [],
      showDropZone: true,
    }));
    setSelectedIdArray([]);
    await dispatch(action.clearReducer());
    await dispatch(
      action.colourProductTesting({
        loggedInUserId,
      }),
    );
  };

  const selectedTests = async (e) => {
    setSupplier(e?.supplier);
    setColour(e?.colour);
    handleSelectedTest(e);
  };

  useEffect(() => {
    if (!Array.isArray(selectedItem?.testReport)) {
      if (selectedItem?.testReport && !isEmpty(selectedItem?.testReport) && selectedItem?.testReport !== null && selectedItem?.testReport?.expiryDate) {
        const classColour = moment().isAfter(selectedItem?.testReport?.expiryDate, 'seconds');
        setAddClassname(classColour);
      }
    } else if (selectedItem?.testReport && !isEmpty(selectedItem?.testReport) && selectedItem?.testReport[0]?.expiryDate) {
      const classColour = moment().isAfter(selectedItem?.testReport[0]?.expiryDate, 'seconds');
      setAddClassname(classColour);
    }
  }, [selectedItem?.testReport]);

  const textClasses = () => {
    return addClassname ? 'text-danger' : 'text-success';
  };

  const DeleteReport = async () => {
    const deleteParam = { id: selectedItem?._id };
    const res = await dispatch(testAction.deleteTestReport(deleteParam, t));
    if (res) {
      setShowConfirmation(false);
      await dispatch(testAction.getAllTest({ searchText: '' }));
    }
  };

  const handleDeleteTR = async () => {
    setShowConfirmation(true);
  };
  const handleToggle = () => {
    setShowConfirmation(false);
  };

  const testReportObject = () => {
    return (
      <div>
        {selectedItem?.testReport?.pdfTitle !== undefined && (
          <>
            <span>{`${selectedItem?.testReport?.pdfTitle} | `}</span>
            <span className={textClasses()}>
              {selectedItem?.testReport?.expiryDate ? moment(selectedItem.testReport.expiryDate).format('DD-MMMM-YYYY') : '--'}
            </span>
            <button type="button" onClick={() => handleDeleteTR()} className="btn" aria-label="button">
              <span className="icon-delete" />
            </button>
          </>
        )}
      </div>
    );
  };

  const handleTestReports = () => {
    return (
      <td>
        <div>
          <span>{selectedItem?.testReport && !isEmpty(selectedItem?.testReport) && selectedItem?.testReport !== null && testReportObject()}</span>
        </div>
      </td>
    );
  };
  const handleMenuOpen = () => {
    setIncreaseZIndex(!increaseZIndex);
  };
  const testTypeOptions = testTypeMaster?.filter((el) => el?.isActive === true);
  return (
    <div className=" table-responsive">
      <table className="table custom-table m-0 mb-3 layout-fixed">
        <thead>
          <tr>
            <th className="w-200px">
              <span className="cursor-pointer">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.TESTING_CODE')}</span>
            </th>
            <th className="w-200px">
              <span className="cursor-pointer">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.TESTING_TYPE')}</span>
            </th>
            <th className="w-120px">
              <span className="cursor-pointer">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.MINIMUM_PASS_RATE')}</span>
            </th>
            <th className="w-250px">
              <span className="cursor-pointer">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.ADDITIONAL_INFO')}</span>
            </th>
            <th className="w-200px">
              <span className="cursor-pointer">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.SUPLIER')}</span>
            </th>
            <th className="w-200px">
              <span className="cursor-pointer">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.COLOUR_REF')}</span>
            </th>
            <th className="w-150px">
              <span className="cursor-pointer">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.TEST_REPORT')}</span>
            </th>
            <th className="w-120px col-result-top-table">
              <span className="cursor-pointer">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.RESULT_STATUS')}</span>
            </th>
            <th className="w-200px col-id-no">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.ACTION')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <Select
                name="testingRef"
                className={increaseZIndex ? 'testing-ref-menu' : ''}
                maxMenuHeight={120}
                menuPosition="fixed"
                onMenuOpen={handleMenuOpen}
                onMenuClose={handleMenuOpen}
                menuPlacement="top"
                options={testList}
                getOptionLabel={(option) => `${option.code} | ${option.description}`}
                getOptionValue={(option) => `${option._id}`}
                value={selectedItem}
                styles={customStyles}
                onChange={selectedTests}
                placeholder={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.TESTING_CODE')}
              />
            </td>
            <td>
              {savedEdit ? (
                <div>
                  <div className="custom-react-select">
                    <Select
                      name="type"
                      maxMenuHeight={120}
                      menuPosition="fixed"
                      menuPlacement="top"
                      key={0}
                      options={testTypeOptions}
                      getOptionLabel={(option) => `${option?.name}`}
                      getOptionValue={(option) => `${option?._id}`}
                      value={type}
                      styles={SystemMasterSelect}
                      onChange={(e) => handleSelectType(e)}
                      placeholder={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.TESTING_TYPE')}
                    />
                  </div>
                  {(isEmpty(selectedItem.type) || selectedItem.type === null || selectedItem.type === '') && (
                    <span className="text-danger m-0 p-1">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.TYPE_IS_REQUIRED')}</span>
                  )}
                </div>
              ) : (
                <span>{selectedItem?.type?.name} </span>
              )}
            </td>
            <td>
              {savedEdit ? (
                <FormGroup>
                  <div>
                    <input
                      name="minPassRate"
                      key={0}
                      className="form-control custom-control-bordered"
                      value={selectedItem?.minPassRate}
                      onChange={(e) => handleChange(e)}
                      type="text"
                      defaultValue={selectedItem?.minPassRate}
                      maxLength="200"
                    />
                  </div>
                  {isEmpty(selectedItem.minPassRate) && (
                    <span className="text-danger m-0 p-1">{t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.MIN_PASS_REQUIRED')}</span>
                  )}
                </FormGroup>
              ) : (
                shortenandHoverString(selectedItem?.minPassRate, 40)
              )}
            </td>
            <td>
              {savedEdit ? (
                <FormGroup>
                  <div>
                    <input
                      name="additionalInformation"
                      key={0}
                      className="form-control custom-control-bordered"
                      value={selectedItem.additionalInformation}
                      onChange={(e) => handleChange(e)}
                      type="text"
                      defaultValue={selectedItem?.additionalInformation}
                      maxLength="200"
                    />
                  </div>
                </FormGroup>
              ) : (
                selectedItem?.additionalInformation
              )}
            </td>
            <td>
              {!savedEdit && (
                <Select
                  name="supplierRef"
                  maxMenuHeight={120}
                  menuPosition="fixed"
                  menuPlacement="top"
                  isClearable
                  options={supplierOptions}
                  getOptionLabel={(option) => `${option?.name}`}
                  getOptionValue={(option) => `${option?._id}`}
                  value={supplier}
                  styles={customStyles}
                  onChange={(e) => handleSelectedSupplier(e)}
                  placeholder={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.SUPLIER')}
                />
              )}
            </td>
            <td>
              {!savedEdit && (
                <Select
                  name="colourRef"
                  maxMenuHeight={120}
                  menuPosition="fixed"
                  menuPlacement="top"
                  isClearable
                  options={colourWayOptions(ProductColourList)}
                  getOptionLabel={(option) => `${option?.name}`}
                  getOptionValue={(option) => `${option?._id}`}
                  value={colour}
                  styles={customStyles}
                  onChange={(e) => handleSelectedColour(e)}
                  placeholder={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.COLOUR_REFRENCE')}
                />
              )}
            </td>
            {handleTestReports()}
            {handleComments(selectedItem)}
            {actionButtons(selectedItem)}
          </tr>
        </tbody>
      </table>
      {showPreviewModal && (
        <ForPreview
          onOpen={showPreviewModal}
          toggle={togglePreview}
          fromTestLib
          showData={selectedItem}
          reportId={!Array.isArray(testingAttributes) && testingAttributes?._id}
          // showData={showData}
        />
      )}{' '}
      {showPdfModal && (
        <UploadTesting
          onOpen={showPdfModal}
          toggle={togglePdfModal}
          isRenewMode={fromRenew}
          fromTestLib={fromTestingLib}
          documentIds={renewState.documentLibId}
          reportIds={renewState.reportIds}
          testIds={renewState.testIds}
          showData={selectedItem}
          renewName={renewState.renewName}
          expairyDate={expectedExpairy}
          supplier={supplier}
          bomComponent={showData}
          colour={colour}
          showDropZone={renewState.showDropZone}
          status={renewState.renewStatus}
          selectedIdArray={selectedIdArray}
          selectedItem={selectedItem}
          setSelecteditem={setSelecteditem}
        />
      )}
      {showConfirmationReDo && (
        <ConfirmationPopup
          onOpen={showConfirmationReDo}
          onConfirm={undoStatus}
          // loading={isLoad}
          title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.STATUS_MESSAGE')}
          message={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.CONFIRMATION_MESSAGE')}
          secondMessage="Linked status would be reinitializes. This action cannot be undone."
          toggle={() => setShowConfirmationReDo(!showConfirmationReDo)}
        />
      )}
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={DeleteReport}
          loading={false}
          title={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.REPORT_CONFIRMATION')}
          message={t('DEVLOPMENT_ORDER.TESTING.TESTING_ATTRIBUTES.TOP_TABLE.DELETE_TEST_REPORT')}
          toggle={() => handleToggle()}
        />
      )}
    </div>
  );
}

export default TopTable;
